import {
  eventListener,
  IPropertySelection,
  ISubscribeSelectedProperty,
  TOPICS,
} from "@origin-digital/event-dispatcher";
import { useEffect, useRef } from "react";
import { deepCopy } from "../utils/objects";

/**
 * Subscribe and unsubscribe to SUBSCRIBE_SELECTED_PROPERTY events, and handle initial response.
 *
 * @return a handler to respond to further selection changes.
 */
export const usePropertySelectionListener = (
  propertySelection: IPropertySelection | null,
  propertyList: IPropertySelection[] | undefined
): void => {
  const subscribersList = useRef<
    ((property: IPropertySelection | null) => IPropertySelection | null)[]
  >([]);
  const propertyRef = useRef<IPropertySelection | null>(propertySelection);

  // on mount, listen for property selection subscribers
  useEffect(() => {
    const handleSubscribeProperty = (event: ISubscribeSelectedProperty) => {
      const { subscriber } = event.payload;
      subscriber(deepCopy(propertyRef.current));
      subscribersList.current.push(subscriber);
      return () =>
        subscribersList.current.splice(
          subscribersList.current.indexOf(subscriber),
          1
        );
    };
    return eventListener.addListener(
      TOPICS.SUBSCRIBE_SELECTED_PROPERTY,
      handleSubscribeProperty
    );
  }, []);

  useEffect(() => {
    propertyRef.current = propertySelection;
    subscribersList.current.forEach((subscriber) => {
      subscriber(deepCopy(propertyRef.current));
    });
  }, [propertySelection, propertyList]);
};
